import React from 'react';

const IslandMarker = (props) => {

    return (
        <div
            className="location-marker"
            data-toggle="tooltip"
        >
                    <span className="marker-tooltip">{props.name}</span>

            <i
                className={"fa fa-lg fa-island-tropical attr solid circle-icon bd-mr-2 mb-2 bg-accent"}
                style={{fontSize: '35px', width: '60px', height: '60px', lineHeight: '50px'}}>
            </i>
        </div>
    )
};

export default IslandMarker;
